import ReportsPage from '@/pages/report/reports/ReportsPage.vue';
import ReportParamsPage from '@/pages/report/reports/ReportParamsPage.vue';
import DisplayReportPage from '@/pages/report/reports/DisplayReportPage.vue';

export default [
  {
    path: '/common/reports/frmReports',
    component: ReportsPage,
  },
  {
    path: '/report-complete-params/',
    component: ReportParamsPage,
  },
  {
    path: '/display-report/',
    component: DisplayReportPage,
  },
];
